<template>
  <div class="control-box">
    <el-form label-width="120px">
      <el-divider content-position="left">邮箱信息</el-divider>
      <div>
        <el-form-item label="邮箱账号数：">
          {{ info.accountCount
          }}<span v-if="info.accountCount > 0"
            >（含禁用邮箱 {{ info.disabledAccountCount }} 个，已删除邮箱
            {{ info.deletedAccountCount }} 个）</span
          >
        </el-form-item>
        <el-form-item label="邮件列表数：">
          {{ info.maillistCount }}
        </el-form-item>
        <el-form-item label="公共联系人数：">
          {{ info.pubAddressCount }}
        </el-form-item>
      </div>
      <el-divider content-position="left">系统状态</el-divider>
      <el-form-item label="LDAP连接状态：">
        <span class="text-danger" v-if="error.ldapErrorExist">
          LDAP连接异常 {{ error.ldapErrorMessage }}
        </span>
        <span v-else>正常</span>
      </el-form-item>
      <el-form-item label="网易连接状态：">
        <span class="text-danger" v-if="error.neteaseErrorExist">
          网易连接异常 {{ error.neteaseErrorMessage }}
        </span>
        <span v-else>正常</span>
      </el-form-item>
      <el-form-item label="完整任务状态：">
        <span v-if="!lastRootRecord">尚未执行完整同步任务</span>
        <span v-else-if="lastRootRecord.state === TASK_STATE.Running">
          最近一次于 {{ lastRootRecord.startTime | dateFormat }}
          开始执行，当前仍在执行中，请稍后...
        </span>
        <span
          v-else-if="lastRootRecord.state !== TASK_STATE.Success"
          class="text-danger"
        >
          最近一次于
          {{ lastRootRecord.startTime | dateFormat }}
          开始执行，未能正常结束<span
            class="text-danger"
            v-if="lastRootRecord.stateMessage"
            >（{{ lastRootRecord.stateMessage }}）</span
          >
        </span>
        <span v-else>
          最近一次于
          {{ lastRootRecord.endTime | dateFormat }} 执行完毕，<span
            :class="{ 'text-danger': lastRootRecord.failed }"
            >{{ lastRootRecord.stateMessage }}</span
          >
        </span>
      </el-form-item>
      <el-divider content-position="left">登录限制</el-divider>
      <el-form-item label="登录IP白名单：">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="设置允许登录后台系统的ip范围，每行代表一组范围, 如留空不限制登录ip"
          v-model="loginIpLimit"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存配置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import ADMIN from "@/api/admin";
import HOME from "@/api/sync/home";
import { TASK_STATE } from "@/constant/taskState";
export default {
  data() {
    return {
      info: {},
      error: {},
      loginIpLimit: "",
      lastRootRecord: null
    };
  },
  created() {
    this.TASK_STATE = TASK_STATE;
    this.fetchData();
  },
  methods: {
    async fetchData() {
      let response = await HOME.SUMMARY();
      if (response.data.state) {
        this.info = response.data.info;
        this.error = response.data.error;
        this.loginIpLimit = response.data.loginIpLimit;
        this.lastRootRecord = response.data.lastRootRecord;
      }
    },
    async onSubmit() {
      let response = await ADMIN.IP_LIMIT({ limit: this.loginIpLimit });
      if (response.data.state) {
        this.loginIpLimit = response.data.value;
        this.$message.success("配置保存成功");
      } else {
        this.$message.error(response.data.message);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.control-box {
  height: 100%;
  padding: 0 10px;
  overflow: auto;
  width: 600px;
}
.el-divider {
  margin: 30px 0;
  .el-divider__text {
    color: #1f8fff;
    font-weight: bold;
  }
}
.el-form {
  ::v-deep * {
    font-size: 13px;
  }
  label.label-red {
    color: #ff9e00;
    margin-left: 6px;
  }
}
</style>
